export default __webpack_public_path__ + "static/media/Ancient Bone Flute.b9d64cfd.jpg";